import Vue from "vue";
import Vuex from "vuex";
import checkout from "./checkout";
import workout from './workout';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    refresh: 0
  },
  mutations: {
    refresh(state) {
      state.refresh++;
    }
  },
  actions: {},
  modules: {
    checkout,
    workout
  }
});
